import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DpuFileSystemService } from './services';
import { dpuFileFeature } from './store';
import { DpuFileEffects } from './store/dpu-file.effect';

type ModuleConfig = {
  dpuService: Provider,
  localStorageService: Provider,
  notificationService: Provider,
  saveFileService: Provider,
  lastSetupFilePathStorageKey: Provider,
  lastSetupFileName: Provider,
  shutdownService: Provider,
};

@NgModule({
  imports: [
    StoreModule.forFeature(dpuFileFeature),
    EffectsModule.forFeature(DpuFileEffects),
  ],
})
export class DpuFileModule {
  public static forRoot(config: ModuleConfig): ModuleWithProviders<DpuFileModule> {
    return {
      ngModule: DpuFileModule,
      providers: [
        config.shutdownService,
        config.dpuService,
        config.localStorageService,
        config.notificationService,
        config.saveFileService,
        config.lastSetupFilePathStorageKey,
        config.lastSetupFileName,
        DpuFileSystemService,
      ],
    };
  }

  public static forChild(): ModuleWithProviders<DpuFileModule> {
    return {
      ngModule: DpuFileModule,
    };
  }
}
